/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_New_DescriptionInputs */

const cs_chat_new_description = /** @type {(inputs: Chat_New_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napište kolegovi nebo založte skupinový chat pro tým.`)
};

const en_chat_new_description = /** @type {(inputs: Chat_New_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message one colleague or start a group for your team.`)
};

/**
* | output |
* | --- |
* | "Message one colleague or start a group for your team." |
*
* @param {Chat_New_DescriptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_new_description = /** @type {((inputs?: Chat_New_DescriptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_New_DescriptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_new_description(inputs)
	return cs_chat_new_description(inputs)
});